/**
 * Modal component for content summarization
 */

import React from 'react'
import { Modal, Button, Input, Tooltip, Icon } from 'antd'
import { useTranslation } from 'react-i18next'

const { TextArea } = Input

const SummarizeModal = ({
  visible,
  onOk,
  onCancel,
  onApplyToAll,
  instructions,
  onInstructionsChange,
  isSummarizing,
  isApplyingAll,
  content,
  onContentChange
}) => {
  const { t } = useTranslation()
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Icon type="edit" style={{ color: '#5057d5', marginRight: 8 }} />
          <span>{t('v4:edit_content_instructions')}</span>
        </div>
      }
      visible={visible}
      onCancel={onCancel}
      centered
      destroyOnClose
      maskClosable={false}
      width={560}
      className="ai-summarize-content"
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
          }}
        >
          <Button onClick={onCancel} className="shl-secondary-btn" size="small">
            {t('buttons:cancel')}
          </Button>
          <div style={{ display: 'flex', gap: 8 }}>
            {/* <Tooltip title="Preview and apply these instructions to all topics">
              <Button
                onClick={onApplyToAll}
                className="shl-secondary-btn"
                size="small"
                loading={isApplyingAll}
              >
                Apply All
              </Button>
            </Tooltip> */}
            <Tooltip
              title={t('v4:generate_content_for_this_topic_instruction')}
            >
              <Button
                onClick={onOk}
                className="shl-primary-btn"
                size="small"
                style={{ padding: '0 2rem' }}
              >
                {isSummarizing && <Icon type="loading" />}
                {!isSummarizing && t('v4:generate_content')}
                {!isSummarizing && (
                  <Icon type="arrow-right" style={{ marginLeft: 6 }} />
                )}
              </Button>
            </Tooltip>
          </div>
        </div>
      }
    >
      <div>
        <div
          style={{
            background: '#fafafa',
            border: '1px solid #e8e8e8',
            borderRadius: 6,
            padding: '12px 12px',
            marginBottom: 12,
            color: 'rgba(0,0,0,0.65)'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            {t('v4:descrip_edit_content')} <br />
            {t('v4:try_short_clear_direcctives')}
          </div>
        </div>
        <TextArea
          autosize={{ minRows: 3, maxRows: 6 }}
          placeholder={t('v5:write_here')}
          value={instructions}
          onChange={onInstructionsChange}
        />
        <div style={{ marginTop: 8, color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>
          {t('v4:we_preserve_the_core_meaning')}
        </div>
      </div>
    </Modal>
  )
}

export default SummarizeModal
